import { gql } from 'graphql.macro';

export const getLabActionsTemplate = gql`
    query labActions(
        $filters: ActionFilters
        $offset: Int
        $limit: Int
        $orderBy: ActionOrderBy
        $orderDirection: OrderDirection
    ) {
        labActions(
            filters: $filters
            offset: $offset
            limit: $limit
            orderBy: $orderBy
            orderDirection: $orderDirection
        ) {
            _id
            actionCode
            internalCode
            denthubRestorationType
            description
            category
            vat
            addedDate
            inactive
            inactivatedDate
            groups {
                _id
                name
            }
            materialMacros {
                _id
                name
            }
            productionPlanningTemplate {
                digitalTemplateId
                physicalTemplateId
            }
            productionValueTemplate {
                digitalTemplateId
                physicalTemplateId
            }
            productionPlanningTemplateName {
                digital
                physical
            }
            productionValueTemplateName {
                digital
                physical
            }
            productionDeductionValue
        }
    }
`;

export const getActionPriceListsTemplate = gql`
    query actionPriceLists($filters: ActionFilters, $offset: Int, $limit: Int) {
        actionPriceLists(filters: $filters, offset: $offset, limit: $limit) {
            _id
            actionPriceListName
            currency
            isStandardPriceList
            actions {
                _id
                action
                actionCode
                description
                category
                addedDate
                vat
                category
                basePrice
                tiotandvardPrice
                groups {
                    _id
                    name
                }
            }
        }
    }
`;

export const getCategoriesTemplate = gql`
    query categories($filters: CategoryFilters, $offset: Int, $limit: Int) {
        categories(filters: $filters, offset: $offset, limit: $limit) {
            _id
            name
        }
    }
`;

export const getGroupsTemplate = gql`
    query groups($filters: GroupFilters, $offset: Int, $limit: Int) {
        groups(filters: $filters, offset: $offset, limit: $limit) {
            _id
            name
        }
    }
`;
